export const TOGGLE_LVZ_SPECIFIC_DETAIL_PANEL = 'TOGGLE_LVZ_SPECIFIC_DETAIL_PANEL'

export function displayLvzSpecificDetailPanelReducer (state = false, action) {
    switch (action.type){
        case TOGGLE_LVZ_SPECIFIC_DETAIL_PANEL:
            return action.payload
        default: return state
    }
}